interface IconSaveProps {
  className?: string;
  duotone?: boolean;
}

export const IconDetailEstimation = ({ className, duotone = true }: IconSaveProps) => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      opacity={duotone ? '0.5' : '1'}
      d='M10 7L2 7'
      stroke='#A0A4AB'
      strokeWidth='1.5'
      strokeLinecap='round'
    />

    <path
      opacity={duotone ? '0.5' : '1'}
      d='M8 12H2'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      opacity={duotone ? '0.5' : '1'}
      d='M10 17H2'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <circle cx='17' cy='12' r='5' stroke='#FFFFFF' strokeWidth='1.5' />
    <path
      d='M17 10V11.8462L18 13'
      stroke='#FFFFFF'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
